import React from "react";
import { FiCheck } from "react-icons/fi";
import Frame from "../layout/Frame";
import Meta from "../layout/Meta";
import Outcomes from "../blocks/Outcomes";
import Channels from "../blocks/Channels";
import Invite from "../blocks/Invite";
import brand from "../db/brand";

const Studio = () => (
  <Frame>
    <Meta title="Studio" description={`${brand.fullName} — performance and programmatic advertising practice based in ${brand.hq.city}.`} />
    <section className="svc-hero">
      <div className="shell">
        <div className="crumb"><a href="/">Home</a><span className="sep">/</span>Studio</div>
        <span className="tag tag--orange">ABOUT NTAC</span>
        <h1 style={{ marginTop: "1.25rem" }}>A performance shop built around incrementality.</h1>
        <p className="lede">
          {brand.fullName} was founded by traders and analytics leads who saw the same pattern repeat — paid-media
          shops winning award decks but losing CFO trust. NTAC was set up to flip that.
        </p>
      </div>
    </section>
    <Outcomes />
    <section className="band">
      <div className="shell">
        <div className="duet">
          <div>
            <span className="tag">ORIGIN</span>
            <h2 style={{ marginTop: "1.25rem" }}>From the trading desk.</h2>
            <p>
              The people running paid media at scale know that platform attribution rarely survives audit. We watched
              this happen across engagement after engagement, then walked. NTAC is the studio that should have existed:
              full-stack performance with the measurement layer rebuilt to the level CFOs expect.
            </p>
            <ul className="tick">
              <li><span className="m"><FiCheck /></span> Senior traders on every account · no junior pass-through</li>
              <li><span className="m"><FiCheck /></span> Incrementality testing baked into every campaign cycle</li>
              <li><span className="m"><FiCheck /></span> Creative production in volume, locally</li>
              <li><span className="m"><FiCheck /></span> CFO-language reporting · every month · in writing</li>
            </ul>
          </div>
          <div className="outcome-card">
            <div className="head">
              <span>PRACTICE · 2026</span>
              <span className="label">SIGNED</span>
            </div>
            <div className="big">92%</div>
            <p className="desc">Of managed media spend operated against an active incrementality test or holdout, on a quarterly cycle.</p>
            <div className="grid-meta">
              <div>
                <div className="k">SENIOR-LED</div>
                <div className="v">10y+ avg</div>
              </div>
              <div>
                <div className="k">INDEPENDENT</div>
                <div className="v">0% kickback</div>
              </div>
              <div>
                <div className="k">SLAs</div>
                <div className="v">In every retainer</div>
              </div>
              <div>
                <div className="k">REPORTING</div>
                <div className="v">CFO language</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section className="band band--paper">
      <div className="shell">
        <div className="head-block">
          <div className="left">
            <span className="tag">CHANNELS</span>
            <h2 style={{ marginTop: "1rem" }}>The full performance stack — under one trading team.</h2>
          </div>
        </div>
        <Channels />
      </div>
    </section>
    <Invite />
  </Frame>
);

export default Studio;
